"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const styled_components_1 = require("styled-components");
const Colors_1 = require("components/styled/Colors");
const Fonts_1 = require("components/styled/Fonts");
const ScreenSizes_1 = require("components/styled/ScreenSizes");
const BtnBase = styled_components_1.default.a `
  border-radius: 55px;
  box-sizing: border-box;
  cursor: pointer;
  display: inline-block;
  font-family: ${Fonts_1.WalsheimFontStack};
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 16px;
  margin-top: 25px;
  padding: 20px 33px;
  text-align: center;
  text-decoration: none;
  width: 100%;

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    margin-top: 40px;
    width: auto;
  }
`;
exports.BtnDandelion = styled_components_1.default(BtnBase) `
  background: ${Colors_1.SPACE};
  border: 1px solid ${Colors_1.DANDELION};
  color: ${Colors_1.DANDELION};

  &:hover {
    background: rgba(15, 15, 16, 0.25);
  }

  &:active {
    background: ${Colors_1.DANDELION};
    color: ${Colors_1.SPACE};
    outline: 0;
  }
`;
exports.BtnBondi = styled_components_1.default(BtnBase) `
  background: ${Colors_1.REGENT};
  border: 1px solid ${Colors_1.BONDI};
  color: ${Colors_1.BONDI};

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  &:active {
    background: ${Colors_1.BONDI};
    border: 1px solid ${Colors_1.BONDI};
    color: ${Colors_1.WHITE};
    outline: 0;
  }
`;
exports.BtnFooter = styled_components_1.default.button `
  background: ${Colors_1.BONDI};
  border: 1px solid ${Colors_1.BONDI};
  border-radius: 100px;
  color: ${Colors_1.WHITE};
  cursor: pointer;
  font-family: ${Fonts_1.WalsheimFontStack};
  font-size: 15px;
  font-weight: 700;
  letter-spacing: 0;
  line-height: 15px;
  margin-bottom: 10px;
  padding: 16px 52px;
  text-align: center;
  text-decoration: none;
  white-space: nowrap;
  width: 100%;

  &:hover {
    opacity: 0.8;
  }

  &:focus {
    outline: 0;
  }

  &:active {
    outline: 0;
  }

  &:disabled {
    opacity: 0.5;
    cursor: default;
  }

  ${ScreenSizes_1.TABLET_PORTRAIT} {
    border: 4px solid ${Colors_1.KARL};
    justify-content: flex-end;
    margin: 1px;
    width: auto;
  }
`;



// WEBPACK FOOTER //
// ./src/components/styled/Buttons.ts